import * as React from 'react';
import { DumbFavoriteButton } from './parts/DumbFavoriteButton';

export interface IFavoriteButtonProps {
  isFavorite: boolean;
  isHeader: boolean;
  gaLabel: string;
  hideText: boolean;
  newbuildingId: number;

  actionAddFavorite(): void;
  actionRemoveFavorite(): void;
}

export class FavoriteButton extends React.Component<IFavoriteButtonProps, {}> {
  public updateFavorite = async (e: React.MouseEvent) => {
    if (this.props.isFavorite) {
      e.stopPropagation();
      this.props.actionRemoveFavorite();
    } else {
      this.props.actionAddFavorite();
    }
  };

  public render(): React.ReactNode {
    const { isFavorite, hideText, isHeader } = this.props;

    return (
      <DumbFavoriteButton
        onClick={this.updateFavorite}
        isFavorite={isFavorite}
        hideText={hideText}
        isHeader={isHeader}
      />
    );
  }
}
